type Room = { name: string; slug: string; description: string | null; category: string | null };

export function roomPresentation(room: Room) {
  const paragraphs = (room.description || '').split(/\n\s*\n/).map(text => text.trim()).filter(Boolean);
  const uk = paragraphs[0]?.startsWith('🇬🇧') || false;
  const sponsored = paragraphs.some(text => /sponsored by OneFiler/i.test(text));
  let summary = paragraphs[0] || `Meet people interested in ${room.name} through short, one-to-one conversations.`;
  for (const emoji of ['🇬🇧', '🇳🇱', '💬']) if (summary.startsWith(emoji)) summary = summary.slice(emoji.length).trim();
  if (summary.startsWith(`${room.name} — `)) summary = summary.slice(room.name.length + 3);
  summary = summary.charAt(0).toUpperCase() + summary.slice(1);
  return {
    emoji: uk ? '🇬🇧' : room.slug.includes('amsterdam') ? '🇳🇱' : '💬',
    label: uk ? 'UK tax community' : room.category || 'Community room',
    summary,
    paragraphs: paragraphs.slice(1).filter(text => !/sponsored by OneFiler/i.test(text)),
    sponsorNote: sponsored ? paragraphs.find(text => /sponsored by OneFiler/i.test(text)) : null,
    sponsored,
  };
}
